import { Link } from "gatsby"
import React, { useCallback, useEffect, useState } from "react"
import Logo from "../../static/logo.svg"
import * as headerStyles from "./header.module.scss"
import * as searchStyles from "./search.module.scss"
import Search from "./search"

const Header = ({ searchIndex, pathname, type }) => {
  const [showMenu, toggleMenu] = useState(null)
  const [scrollClass, setClass] = useState("")
  const [backdrop, showBackdrop] = useState(null)

  const handleNavigation = useCallback(e => {
    const currWin = e.currentTarget
    if (currWin.scrollY < 1) {
      setClass("")
    } else if (currWin.scrollY > 1) {
      setClass("scrollUp")
    }
  })

  useEffect(() => {
    window.addEventListener("scroll", handleNavigation)

    return () => {
      window.removeEventListener("scroll", handleNavigation)
    }
  }, [handleNavigation])

  return (
    <>
      <div
        className={`${headerStyles.header} ${
          showMenu === null
            ? ""
            : showMenu === true
            ? headerStyles.open
            : headerStyles.close
        }`}
      >
        <div
          className={`${headerStyles.hamburger} ${
            showMenu ? headerStyles.active : ""
          }`}
          onClick={() => {
            toggleMenu(!showMenu)
            if (showMenu) {
              document.body.classList.add("menu-close")
              document.body.classList.remove("menu-open")
              setTimeout(() => {
                showBackdrop(!showMenu)
              }, 300)
            } else {
              document.body.classList.add("menu-open")
              document.body.classList.remove("menu-close")
              showBackdrop(!showMenu)
            }
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div className={headerStyles.logo}>
          <Link target="_blank" to={"/"}>
            <img
              src={Logo}
              alt={`fundingfyre`}
              className={headerStyles.lrLogo}
            />
          </Link>
        </div>
        <ul className="navbar-nav" style={{"listStyle": "none","marginTop": "27px"}}>
          <li className="nav-link" style={{"display": "inline-block","margin": "5px 10px"}}>
          <Link to="https://fundingfyre.com/decks">Pitch Decks</Link>
          </li>
          <li className="nav-link" style={{"display": "inline-block","margin": "5px 10px"}}>
          <Link to="https://fundingfyre.com/memos">Investment Memos</Link>
          </li>
          <li className="nav-link" style={{"display": "inline-block","margin": "5px 10px"}}>
          <Link to="https://fundingfyre.com/videos">Pitch Videos</Link>
          </li>
        </ul>
        <Search
          customClass={`${
            showMenu ? searchStyles.deactive : searchStyles.active
          }`}
          searchIndex={searchIndex}
        />
        <div
        className={`${headerStyles.navigation} ${
          showMenu === null
            ? ""
            : showMenu === true
            ? headerStyles.open
            : headerStyles.close
        }  ${scrollClass}`}
      >
        <ul>
          <li>
            <Link target="_blank" to={"https://fundingfyre.com/login"} style={{"borderBottom": "1px solid #e63946", "padding": "0", "margin": "0 10px"}}>Login</Link>
          </li>
          <li>
            <Link target="_blank" to={"https://fundingfyre.com/get-access"} className="btn btn-primary">Get Access</Link>
          </li>
        </ul>
      </div>
      </div>
      {backdrop === true && (
        <div
          onClick={() => {
            toggleMenu(!showMenu)
            if (showMenu) {
              document.body.classList.add("menu-close")
              document.body.classList.remove("menu-open")
              setTimeout(() => {
                showBackdrop(!showMenu)
              }, 300)
            } else {
              document.body.classList.add("menu-open")
              document.body.classList.remove("menu-close")
              showBackdrop(!showMenu)
            }
          }}
          className={`${headerStyles.backdrop} ${
            showMenu === null
              ? ""
              : showMenu === true
              ? headerStyles.open
              : headerStyles.close
          }`}
        >
          &nbsp;
        </div>
      )}
    </>
  )
}
export default Header
